<template>
    <div class="schedule-item-details-modal">
        <template v-if="event.isFeatured">
            <img class="featured-event-details-image" v-bind:src="getFeaturedEventImage(event.starts)" />
            <span class="x-close" v-on:click="$emit('close')">X</span>
            <template v-if="isApplyButtonVisible">
                <template v-if="isAppliedOrFavorited">
                    <button class="save-or-apply remove-featured" alt="Izbriši predavanje" v-on:click="$emit('remove', event)">
                        {{event.type === 'Workshop' ? 'IZBRIŠI PRIJAVU' : 'MAKNI IZ FAVORITA'}}
                    </button>
                </template>
                <template v-else>
                    <img v-bind:class="['featured-add', isApplyButtonDisabled ? 'max-participants' : '']" src="../../assets/app-icons/event-details/add.svg" alt="Spremi" v-on:click="saveEvent()" />
                </template>
            </template>
        </template>
        <template v-else>
            <img class="close" src="../../assets/app-icons/event-details/close.svg" alt="Zatvori" v-on:click="$emit('close')" />
            <template v-if="isApplyButtonVisible">
                <template v-if="isAppliedOrFavorited">
                    <button class="save-or-apply" alt="Izbriši predavanje" v-on:click="$emit('remove', event)">
                        {{event.type === 'Workshop' ? 'IZBRIŠI PRIJAVU' : 'MAKNI IZ FAVORITA'}}
                    </button>
                </template>
                <template v-else>
                    <button v-bind:class="['save-or-apply', isApplyButtonDisabled ? 'max-participants' : '']"  v-on:click="saveEvent()">
                        <img src="../../assets/app-icons/event-details/add.svg" alt="Dodaj predavanje" />
                        {{event.type === 'Workshop' ? 'PRIJAVI SE' : 'DODAJ U RASPORED'}}
                    </button>
                </template>
            </template>
        </template>
        <div class="schedule-item-details-modal-content">
            <div class="details-header">
                <div class="time">{{ event.starts | filterTimeFromDate }}-{{ event.ends | filterTimeFromDate }}</div>
                <div class="theme dev" v-if="event.theme === 'Dev'">DEV</div>
                <div class="theme design" v-else-if="event.theme === 'Design'">DESIGN</div>
                <div class="theme tech" v-else-if="event.theme === 'Tech'">TECH</div>
                <div class="theme marketing" v-else-if="event.theme === 'Marketing'">MARKETING</div>
            </div>
            <div class="details-title">
                {{event.name}}
            </div>
            <div class="details-description">
                <p v-if="event.description">
                    {{ event.description }}
                </p>
                <div v-if="event.eventUsers && event.eventUsers.length">
                    <div class="user-container" v-for="eventUser in getSortedEventUsers(event)" v-bind:key="eventUser.userId">
                        <div class="user-details" v-if="eventUser.user && eventUser.user.hasImage">
                            <div>
                                <img v-bind:src="getSpeakerImage(getSpeakerNameNormalized(eventUser.user.firstName + eventUser.user.lastName))" v-bind:alt="`${eventUser.user.firstName} ${eventUser.user.lastName}`"/>
                            </div>
                            <div>
                                <div>
                                    {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}
                                </div>
                                <span v-if="eventUser.user.lecturerTitle && eventUser.user.lecturerTitle.length"> ({{ eventUser.user.lecturerTitle }})</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showPreviousNextControls" class="schedule-item-details-modal-footer">
            <div v-on:click="$emit('previous', event.type)">
                <img src="../../assets/app-icons/event-details/next.svg" alt="Prethodno predavanje" />
                Prethodno
            </div>
            <div v-on:click="$emit('next', event.type)">
                Sljedeće
                <img src="../../assets/app-icons/event-details/next.svg" alt="Sljedeće predavanje" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ScheduleItemDetailsModal',
        data() {
            return {
                isApplyButtonDisabled: false,
                isApplyButtonVisible: true
            }
        },
        props: {
            event: {},
            showPreviousNextControls: Boolean,
            isAppliedOrFavorited: Boolean
        },
        methods: {
            getSpeakerImage: function(speakerNameNormalized) {
                return require(`../../assets/speakers/images/${speakerNameNormalized}.jpg`);
            },
            getSpeakerNameNormalized: function(speakerName) {
                return speakerName.replace(/\s/g, '').toLowerCase();
            },
            getFeaturedEventImage: function(startDateTime) {
                return require(`../../assets/events/featured-${startDateTime.replace(/\s/g, '').replace(/:/g,'-')}.jpg`);
            },
            saveEvent: function() {
                if(this.isApplyButtonDisabled)
                {
                    alert('Već je prijavljen maksimalan broj sudionika za taj događaj.');
                    return;
                }

                this.$emit('save', this.event);
            },
            getSortedEventUsers: function(event) {
                return event.eventUsers.filter(eu => eu.user !== null).sort(function(firstEventUser, secondEventUser) {
                    if(firstEventUser.userEventRole < secondEventUser.userEventRole)
                        return -1;
                    else if(firstEventUser.userEventRole > secondEventUser.userEventRole)
                        return 1;
                    if(firstEventUser.user.lastName < secondEventUser.user.lastName)
                        return -1;
                    return 1;
                });
            }
        },
        created() {
            if(this.event.type === 'Workshop')
                this.$axios.get(`${this.$API_URL}/events/number-of-participants/${this.event.id}`)
                .then(response => {
                    if(response.data >= this.event.maxParticipants)
                        this.isApplyButtonDisabled = true;
                });
            
            let currentDateTime = new Date();
            let eventDateTime = new Date(this.event.starts);

            if(currentDateTime > eventDateTime && !this.isAppliedOrFavorited)
                this.isApplyButtonVisible = false;
        },
        mounted() {
            document.body.classList.add('modal-open');
        },
        beforeDestroy() {
            document.body.classList.remove('modal-open');
        }
    }
</script>

<style scoped>
.schedule-item-details-modal {
  font-family: "Fuse V.2 Display";
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: #fff;
  overflow-y: scroll;
}

.schedule-item-details-modal-content {
    padding-bottom: 50px;
    padding-left: 20px;
}

.close:hover {
    cursor: pointer;
}

.save-or-apply {
    display: flex;
    align-items: center;
    border: none;
    background-color: #30cec1;
    color: white;
    padding: 7px 10px;
    border-radius: 5px;
    position: absolute;
    right: 20px;
    top: 40px;
}

.save-or-apply img {
    margin-right: 6px;
}

.save-or-apply:hover {
    cursor: pointer;
}

.save-or-apply.remove-featured {
    top: 24px;
}

.theme {
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    margin-right: 10px;
    border-radius: 3px;
}

.theme.dev {
    background-color: #30cec1;
}

.theme.design {
    background-color: #FF575F;
}

.theme.tech {
    background-color: #2C373F;
}

.theme.marketing {
    background-color: #D6BD42;
}

.time {
    font-size: 14px;
    opacity: 0.5;
    margin-right: 20px;
}

.header {
    display: flex;
    margin-bottom: 10px;
}

.details-header {
    margin-top: 20px;
    margin-bottom: 15px;
    display: flex;
}

.details-title {
    font-size: 20px;
    font-weight: 800;
    padding-right: 20px;
}

.details-description p {
    font-size: 14px;
    line-height: 25px;
    opacity: 0.75;
    padding-right: 20px;
    text-align: justify;
}

.schedule-item-details-modal-footer {
    position: fixed;
    bottom: 0;
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
    font-size: 12px;
    width: 100%;
    background-color: white;
}

.schedule-item-details-modal-footer div {
    display: flex;
    align-items: center;
    opacity: 0.7;
}

.schedule-item-details-modal-footer div:hover {
    cursor: pointer;
}

.schedule-item-details-modal-footer div:first-of-type {
    margin-left: 20px;
}

.schedule-item-details-modal-footer div:first-of-type img {
    transform: rotate(180deg);
    margin-right: 5px;
}

.schedule-item-details-modal-footer div:last-of-type {
    margin-left: auto;
    margin-right: 20px;
}

.schedule-item-details-modal-footer div:last-of-type img {
    margin-left: 5px;
}

.user-container {
    display: flex;
    flex-wrap: wrap;
}

.user-details {
    display: flex;
    align-items: center;
    margin-right: 30px;
    margin-top: 10px;
}

.user-details img {
    height: 70px;
    width: 70px;
    border-radius: 15px;
    margin-right: 10px;
}

.featured-event-details-image {
    max-height: 180px;
    width: 100%;
}

.x-close {
    color: white;
    transform: scale(2.5, 1.5);
    position: absolute;
    top: 30px;
    left: 30px;
    font-weight: 200;
}

.x-close:hover {
    cursor: pointer;
}

.featured-add {
    position: absolute;
    top: 34px;
    right: 30px;
    transform: scale(1.5);
}

.featured-add:hover {
    cursor: pointer;
}

.schedule-item-details-modal .max-participants {
    opacity: 0.5;
}
</style>